import LinkExtension from '@tiptap/extension-link';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import { menuControlFor } from './_get_menu_control';

const syncMenu = ({ editor }) => {
  const control = menuControlFor(editor, 'link:set');
  const controlIsActive = editor.isActive('link');

  control?.classList?.toggle('active', controlIsActive);
};

const linkConfig = {
  openOnClick: false,
  autoLink: true,
  HTMLAttributes: {
    target: '_blank',
  },
};

const linksMenuConfig = {
  pluginKey: 'linksContextualMenu',
  shouldShow: ({ editor }) => editor.isActive('link'),
  // element is assigned per-editor in LinksMenu#addProseMirrorPlugins
  options: {
    placement: 'right',
    offset: 8,
    flip: {},
  },
};

const Link = LinkExtension.extend({
  onSelectionUpdate: syncMenu,
  onTransaction: syncMenu,
});

const LinksMenu = BubbleMenu.extend({
  name: 'LinksMenu',
  addProseMirrorPlugins() {
    const editorElement = this.editor.options.element;
    const app = editorElement?.closest('[role="application"]');
    const template = app?.querySelector('[data-js-template="links-contextual-menu"]');
    this.options.element = template
      ? template.content.cloneNode(true).firstElementChild
      : document.createElement('div');
    return this.parent?.() ?? [];
  },
});

export default [Link.configure(linkConfig), LinksMenu.configure(linksMenuConfig)];
